export default "__VITE_ASSET__CAsHJWMU__"